import { useHistory } from "react-router-dom";

/**
 * This function makes going to a previous path easier.
 * In case users are in a new tab (there's no history),
 * they will be sent to the defaultPath provided
 */
export function useGoBackOrDefaultPath(defaultPath: string): () => void {
  const history = useHistory();
  return () => {
    if (history.length === 1) {
      return history.push(defaultPath);
    }
    return history.goBack();
  };
}
